export default "__VITE_ASSET__8ff1dec9__"